import { css } from '@emotion/react';

export const colors = {
    primaryBlue: '#007ed0',
    mediumBlue: '#1565c0',
    darkBlue: '#00447c',
    lightBlue: '#009fee',

    lightGray: '#898686',
};

// 레이어 목록 테마 컬러
export const PANEL_THEME = '#002755';

export const style = {
    // 공통 적용 스타일
    mh10: css`
        margin: 10px 0 10px 0;
    `,

    mt5: css`
        margin-top: 5px;
    `,

    commonButton: css`
        font-weight: 500;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${colors.darkBlue}
        color: white;
        gap: 8px;
        cursor: pointer;
        transition: color 0.2s, background-color 0.2s;

        width: fit-content;
        margin: 0 auto;

        &:hover {
            background-color: ${colors.primaryBlue};
        }
    `,

    // IconTabMenu 관련 스타일
    iconTabArea: css`
        width: 80px;
        flex-shrink: 0;
        background-color: #f7f7f7;
        border-right: 1px solid #ddd;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        position: relative;
        transition: width 0.25s ease;
        padding-top: 10px;
    `,

    iconTabAreaCollapsed: css`
        width: 50px;
    `,

    tabList: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 2px;
    `,

    tabDivider: css`
        width: 60%;
        height: 1px;
        background-color: #d9dce4;
        margin: 6px auto 2px;
    `,

    iconTabButton: css`
        width: 100%;
        height: 52px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #4a4d57;
        font-size: 12px;
        cursor: pointer;
        margin-bottom: 4px;
        transition: color 0.2s, background-color 0.2s;
        box-sizing: border-box;
        text-align: center;
        
        .tab-icon {
            font-size: 16px; 
            margin-bottom: 4px;
        }

        & svg {
            fill: currentColor;
            transition: fill 0.2s;
        }

        &:hover {
            color: ${colors.primaryBlue};
        }
    `,

    iconTabButtonActive: css`
        color: white;
        background-color: ${colors.primaryBlue};

        & svg {
            fill: white;
        }

        &:hover {
            color: white;
            background-color: ${colors.mediumBlue};
        }
    `,

    iconTabButtonCollapsed: css`
        .tab-label {
            display: none;
        }
    `,

    utilityButton: css`
        width: 100%;
        border: none;
        background: transparent;
        cursor: pointer;
        padding: 8px 6px;
        margin-top: 4px;
        color: ${colors.primaryBlue};
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        font-size: 12px;

        .tab-icon {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &:hover {
            color: ${colors.darkBlue};
        }
    `,

    utilityButtonCollapsed: css`
        .tab-label {
            display: none;
        }
    `,

    collapseToggleButton: css`
        position: absolute;
        top: 50%;
        width: 20px;
        height: 36px;
        border: 1px solid ${colors.primaryBlue};
        border-radius: 12px;
        background: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${colors.primaryBlue};
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
        transition: background-color 0.2s, color 0.2s, transform 0.2s;
        z-index: 5;

        &:hover {
            background-color: ${colors.primaryBlue};
            color: #fff;
        }
    `,

    collapseToggleButtonExpanded: css`
        right: 0;
        transform: translate(100%, -50%);
    `,

    collapseToggleButtonCollapsed: css`
        right: -14px;
        transform: translate(50%, -50%);
    `,

    // TabContentArea 관련 스타일
    tabContentArea: css`
        flex-grow: 1;
        padding: 15px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        height: 100%;
    `,

    geocoderHeader: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 5px;
        margin-bottom: 5px;
        padding-bottom: 15px;
    `,

    layerHeader: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding-bottom: 15px;
        // border-bottom: 1px solid #eee;
    `,
    layerTitle: css`
        font-size: 18px;
        font-weight: bold;
        color: #333;
    `,
    dataAddButton: css`
        padding: 8px 15px;
        background-color: ${colors.darkBlue};
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 5px;
        transition: background-color 0.2s;

        &:hover {
            background-color: ${colors.mediumBlue};
        }

        & svg {
            stroke-width: 3.5px;
        }
    `,
    noDataMessage: css`
        text-align: center;
        padding: 20px;
        color: #666;
        font-size: 14px;
        margin-top: 20px;
    `,

    inputLabel: css`
        font-size: 14px;
    `,

    // 지도 영역
    mapArea: css`
        display: flex;
        position: relative;
        box-sizing: border-box;
        max-width: 68vw;
        width: 100%;
        height: 100%;
        flex: 1;

        .ol-zoom {
            position: absolute;
            background-color: rgba(255, 255, 255, 0.4);
            border-radius: 4px;
            padding: 2px;
            top: 1em;
            right: 1em;
        }

        .ol-control button {
            display: flex;
            margin: 1px;
            font-size: 12px;
            font-weight: bold;
            justify-content: center;
            text-align: center;
            height: 16px;
            width: 16px;
            border: none;
            color: black;
            background-color: white;
        }

        .ol-zoom-in {
            border-radius: 2px 2px 0px 0px;
            cursor: pointer;
        }

        .ol-zoom-out {
            border-radius: 0px 0px 2px 2px;
            cursor: pointer;
        }

        .ol-rotate {
            display: none;
        }

        .ol-attribution {
            display: flex;
            flex-direction: row-reverse;
            justify-content: center;
            align-items: center;
            position: absolute;

            font-size: 10px;
            background-color: #ffffffcc;
            border-radius: 4px;
            padding: 2px 0px;
            bottom: 1em;
            right: 1em;
        }

        .ol-attribution button {
            display: flex;
            align-items: center;
            border-radius: 2px;
            background-color: #ffffff;
            cursor: pointer;
        }

        .ol-attribution ul {
            padding: 0px 5px;
        }

        .ol-attribution ul a {
            text-decoration: none;
            color: #000000;
        }

        .ol-attribution button[aria-expanded='false'] + ul {
            display: none;
        }

        .ol-popup {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            background-color: white;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            border: 1px solid #cccccc;
            bottom: 12px;
            left: -50px;
            width: 170px;
            height: 60px;
        }
        .ol-popup:after,
        .ol-popup:before {
            top: 100%;
            border: solid transparent;
            content: ' ';
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }
        .ol-popup:after {
            border-top-color: white;
            border-width: 10px;
            left: 48px;
            margin-left: -10px;
        }
        .ol-popup:before {
            border-top-color: #cccccc;
            border-width: 11px;
            left: 48px;
            margin-left: -11px;
        }
        .ol-popup-closer {
            text-decoration: none;
            position: absolute;
            top: 2px;
            right: 8px;
            cursor: pointer;
        }
        .ol-popup-closer:after {
            content: '✖';
        }

        .ol-popup #popup-content {
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .ol-popup #name {
            font-size: 13px;
            margin-bottom: 5px;
        }

        .ol-popup #content {
            font-size: 14px;
            font-weight: bold;
        }
    `,

    // 데이터 추가 모달창
    modalOverlay: css`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5); /* 50% 투명도의 검은색 배경 */
        display: flex;
        justify-content: center; /* 수평 중앙 정렬 */
        align-items: center; /* 수직 중앙 정렬 */
        z-index: 1000;
    `,

    modalContainer: css`
        background: white;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        width: 600px;
        max-width: 90vw;
        position: relative;
    `,

    modalHeader: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eee;
        padding-bottom: 15px;
        margin-bottom: 20px;
        
        & h3 {
            font-size: 18px;
            font-weight: 600;
            margin: 0;
        }
        
        & button {
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #666;
            padding: 0;
        }
    `,

    modalSectionTitle: css`
        font-size: 15px;
        font-weight: 600;
        margin: 0 0 10px 0;
        color: #333;
    `,

    modalUploadInfo: css`
        font-size: 11px;
        color: #666;
        margin-bottom: 15px;
        
        & ul {
            padding-left: 15px;
            margin: 5px 0 0 0;
            list-style: disc; /* 점 리스트 스타일 */
        }
        & li {
            margin-bottom: 5px;
        }
    `,

    modalDragDropArea: css`
        border: 2px dashed #ddd;
        border-radius: 6px;
        padding: 40px 20px;
        text-align: center;
        color: #999;
        font-size: 14px;
        margin-bottom: 40px;
        
        & button {
            background-color: ${colors.darkBlue};
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            margin-top: 15px;
            font-weight: 500;
        }
    `,

    modalDownloadContainer: css`
        display: flex;
        gap: 15px;
        margin-top: 20px;
        width: 100%;
    `,

    modalDownloadButton: css`
        border: 1px solid #002755;
        color: #002755;
        background-color: #fff;
        flex: 1;


        // flex-grow: 1;
        // background-color: #f5f5f5;
        // color: #333;
        // border: 1px solid #ddd;
        padding: 12px 15px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: background-color 0.2s;
        
        // &:hover {
        //     background-color: #eee;
        // }

        &:hover {
            border-color: #00183a;
            background-color: #eef2ff;
        }
        
        /* 다운로드 아이콘 스타일 */
        & span.icon {
            font-size: 16px; 
            margin-left: 10px;
            color: ${colors.mediumBlue};
        }
    `,

    modalInfoText: css`
        font-size: 11px;
        color: ${colors.lightGray};
        line-height: 1.5;
    `,

    // 레이어 목록
    panelStyles: css`
        margin-top: 24px;
        border: 1px solid #dfe4ec;
        border-radius: 16px;
        padding: 20px;
        background: #fff;
        display: flex;
        flex-direction: column;
        gap: 16px;
    
        .panel-header {
            display: flex;
            justify-content: space-between;
            gap: 12px;
            align-items: flex-start;
        }
    
        .panel-title {
            font-size: 1.1rem;
            font-weight: 700;
            color: ${PANEL_THEME};
            margin: 0;
        }
    
        .panel-subtitle {
            display: block;
            font-size: 0.9rem;
            color: #6b778a;
            margin-top: 2px;
        }
    
        .panel-count {
            font-size: 0.85rem;
            font-weight: 600;
            color: #51627a;
            background: #eff3f9;
            border-radius: 999px;
            padding: 4px 10px;
            white-space: nowrap;
        }
    
        .empty-state {
            padding: 32px 16px;
            border: 1px dashed #bec7d5;
            border-radius: 12px;
            text-align: center;
            color: #5d6b82;
            display: flex;
            flex-direction: column;
            gap: 6px;
        }
    
        .layer-stack {
            display: flex;
            flex-direction: column;
            gap: 2px;
        }
    
        .layer-card {
            position: relative;
            border: 1px solid #d7dde8;
            border-radius: 4px;
            background: #fff;
            padding: 6px 10px 6px 14px;
            display: flex;
            flex-direction: column;
            gap: 6px;
            cursor: grab;
            box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
            transition: box-shadow 0.2s ease, border-color 0.2s ease;
        }
    
        .layer-card::before {
            content: '';
            position: absolute;
            left: 0;
            top: 10px;
            bottom: 10px;
            width: 4px;
            border-radius: 4px;
            background: transparent;
            transition: background 0.2s ease;
        }
    
        .layer-card.collapsed::before {
            background: rgba(0, 39, 85, 0.35);
        }
    
        .layer-card.collapsed:hover::before {
            background: rgba(0, 39, 85, 0.6);
        }
    
        .layer-card.collapsed.selected::before {
            background: ${PANEL_THEME};
        }
    
        .layer-card:hover {
            border-color: #b8c2d9;
            box-shadow: 0 3px 8px rgba(15, 23, 42, 0.1);
        }
    
        .layer-card.selected {
            border-color: ${PANEL_THEME};
            box-shadow: 0 4px 10px rgba(0, 39, 85, 0.12);
        }
    
        .layer-header {
            display: flex;
            align-items: center;
            gap: 12px;
            justify-content: space-between;
        }
    
        .drag-handle {
            border: none;
            background: transparent;
            color: #9aa4b8;
            cursor: grab;
            padding: 4px 2px;
            display: flex;
            align-items: center;
        }
    
        .expand-toggle {
            border-color: #c9d1df;
            background: #f4f7fb;
            color: #4b5973;
        }
    
        .layer-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            cursor: pointer;
            gap: 2px;
        }
    
        .layer-info-header {
            display: flex;
            align-items: center;
            gap: 8px;
        }
    
        .layer-name {
            font-weight: 600;
            color: #0f172a;
            letter-spacing: -0.01em;
        }
    
        .layer-meta {
            font-size: 0.7rem;
            color: #8a94ab;
            text-transform: uppercase;
            letter-spacing: 0.08em;
        }
    
        .geometry-icons {
            display: flex;
            gap: 4px;
            align-items: center;
        }
    
        .geometry-icons {
            display: flex;
            gap: 4px;
            align-items: center;
        }
    
        .geometry-icon {
            font-family: 'font-gis' !important;
            font-size: 18px;
            width: 32px;
            height: 24px;
            border-radius: 4px;
            border: 1px solid #d5ddee;
            background: #f9fbff;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #0f62fe;
        }
    
        .geometry-icon.line {
            color: #0aa679;
        }
    
        .geometry-icon.polygon {
            color: #e17f0e;
        }
    
        .layer-actions {
            display: flex;
            align-items: center;
            gap: 4px;
            padding: 0 4px;
        }
    
        .action-divider {
            height: 20px;
            margin: 0 6px;
        }
    
        .icon-button {
            width: 32px;
            height: 32px;
            border-radius: 4px;
            border: 1px solid #d1d9e9;
            background: #fff;
            color: #3d4a63;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
        }
    
        .icon-button:hover {
            background: #eef2fb;
            border-color: #b8c2d9;
            box-shadow: 0 2px 6px rgba(0, 39, 85, 0.12);
        }
    
        .layer-body {
            border-top: 1px solid #e3e9f3;
            padding-top: 12px;
            display: flex;
            flex-direction: column;
            gap: 16px;
        }
    
        .section {
            display: flex;
            flex-direction: column;
            gap: 12px;
            background: #fff;
            border: 1px solid #e6ecf5;
            border-radius: 12px;
            padding: 12px;
        }
    
        .section-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    
        .section-title {
            display: flex;
            align-items: center;
            gap: 6px;
            font-weight: 600;
            color: #1f2a44;
        }
    
        .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
            gap: 12px;
        }
    
        .palette-row {
            display: flex;
            width: 100%;
        }
    
        .palette-row .MuiTextField-root {
            flex: 1;
        }
    
        .classification-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 12px;
        }
    
        .classification-grid.secondary {
            grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
        }
    
        .classification-actions {
            display: flex;
            justify-content: flex-end;
            margin-top: 8px;
        }
    
        .style-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            gap: 16px;
        }
    
        .geometry-block {
            border: 1px solid #e2e8f4;
            border-radius: 12px;
            padding: 10px 12px;
            background: #fdfefe;
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
    
        .dual-row {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
            gap: 12px;
        }
    
        .dual-row .MuiTextField-root {
            width: 100%;
        }
    
        .color-field .MuiOutlinedInput-input {
            padding: 6px;
            height: 38px;
        }
    
        .color-field input[type='color'] {
            padding: 0;
            border: none;
            height: 38px;
        }
    
        .slider-field {
            display: flex;
            flex-direction: column;
            gap: 4px;
        }
    
        .slider-label {
            display: flex;
            justify-content: space-between;
            font-size: 0.8rem;
            color: #4f5a6f;
        }
    
        .classification-apply-button {
            background: ${PANEL_THEME};
            color: #fff;
            box-shadow: none;
        }
    
        .classification-apply-button:hover {
            background: #001a3d;
            color: #fff;
        }
    `,

};
